import * as TypeStyle from 'typestyle';
import {
  InteractiveBorderColors, InvertInteractiveBorderColors, InvertTextColors, TextColors, TextFieldBorderColors, TextFieldHoverColor
} from '../../styles/Colors';
import { DefaultFocusIndicator, ErrorFocusIndicator, ValidFocusIndicator } from '../../styles/FocusIndicators';
import { PreventUserSelect } from '../../styles/PreventUserSelect';

const ErrorColor = TextFieldBorderColors.Error;
const ValidColor = TextFieldBorderColors.Valid;

const ButtonHeight = 24;
export const BorderWidth = 1;

export const ChildrenClassName = TypeStyle.style({
  alignItems: 'center', // vertically align to center of container
  alignSelf: 'stretch', // fill the container height
  display: 'inline-flex',
  flexGrow: 1,
  minHeight: ButtonHeight - BorderWidth * 2,
  overflow: 'hidden',
  padding: '0 7px',
  $nest: {
    '.icon > &': { flexGrow: 0, padding: 0 },
  }
});

export const ClassName = TypeStyle.style(PreventUserSelect, {
  alignItems: 'center',
  backgroundColor: 'transparent', // override UA default
  border: `${BorderWidth}px solid transparent`,
  borderRadius: 1,
  boxSizing: 'border-box',
  color: TextColors.Primary,
  display: 'flex',
  fontFamily: 'inherit',
  fontSize: 12,
  lineHeight: 'normal',
  padding: 0,
  position: 'relative',

  $nest: {
    '&.outline': InteractiveBorderColors,
    '&.line': InteractiveBorderColors,
    '&&&.line': {
      borderLeftColor: 'transparent', borderRightColor: 'transparent', borderTopColor: 'transparent',
      borderBottomLeftRadius: 0, borderBottomRightRadius: 0,
    },
    '&.text, &.icon': {
      display: 'inline-flex',
    },
    '&.text:enabled, &.icon:enabled': {
      cursor: 'pointer',
    },

    '&:hover:enabled': { backgroundColor: TextFieldHoverColor },
    '&&&:active:enabled': { backgroundColor: '#c9c9c9' },
    '&&&&:focus-visible': DefaultFocusIndicator(),

    // valid state is basically deprecated in the DLS, we should probably just delete it
    '.valid > &': {
      $nest: {
        '&.outline, &.line': { borderColor: ValidColor },
      }
    },
    '.valid > &&&&:focus-visible': ValidFocusIndicator,

    '&[aria-invalid="true"]': {
      $nest: {
        '&.outline, &.line': { borderColor: ErrorColor },
        '&&&:focus-visible': ErrorFocusIndicator,
      }
    },

    '.dark > &': {
      backgroundColor: 'transparent !important',
      color: InvertTextColors.Primary,
    },
    '.dark > &.outline': InvertInteractiveBorderColors,
    '.dark > &.line': InvertInteractiveBorderColors,
    '.dark > &&&:focus-visible': DefaultFocusIndicator({ invert: true }),
  }
});

export const PopupContainerStyle: React.CSSProperties = Object.freeze({
  position: 'absolute',
});
